module.exports = __webpack_public_path__ + "static/media/launcher_button.0e70913b.svg";